<template>
  <v-data-table
    ref="table"
    dense
    fixed-header
    :headers="headers"
    :items-per-page="-1"
    :items="editedItem"
    hide-default-footer
    class="elevation-1 collateral-compact-table"
  >
    <template v-slot:top>
      <div class="d-flex justify-end">
        <v-btn
          class="mx-2" color="primary"
          fab icon x-small
          @click="addOne"
        >
          <v-icon>
            {{icons.mdiPlus}}
          </v-icon>
        </v-btn>
      </div>
    </template>

    <template v-slot:[`item.asOfDate`]="{ item }">
      <ClarionDateControl
        v-model="item.asOfDate"
        label="As Of Date"
        :isToggle="false"
        dense
        single-line
        hide-details="auto"
        @blurred="somethingChanged"
      />
    </template>

    <template v-slot:[`item.loc`]="{ item }">
      <v-text-field
        v-model="item.loc"
        label="LOC/Collateral"
        dense
        single-line
        hide-details
        @blur="somethingChanged"
        @keydown.enter="somethingChanged"
      ></v-text-field>
    </template>

    <template v-slot:[`item.pledges`]="{ item }">
      <v-text-field
        v-model="item.pledges"
        dense
        single-line
        hide-details
        label="Pledges"
        @blur="somethingChanged"
        @keydown.enter="somethingChanged"
      ></v-text-field>
    </template>

    <template v-slot:[`item.sweep`]="{ item }">
      <v-text-field
        v-model="item.sweep"
        dense
        single-line
        hide-details
        label="Sweep"
        @blur="somethingChanged"
        @keydown.enter="somethingChanged"
      ></v-text-field>
    </template>

    <template v-slot:[`item.fdic`]="{ item }">
      <v-text-field
        v-model="item.fdic"
        label="FDIC"
        dense
        single-line
        hide-details
        @blur="somethingChanged"
        @keydown.enter="somethingChanged"
      ></v-text-field>
    </template>

    <template v-slot:[`item.delActions`]="{ item }">
      <v-icon
        small class="mr-2"
        tabindex="-1"
        @click="removeOne(item)"
      >
        {{icons.mdiDelete}}
      </v-icon>
    </template>

    <!-- <template v-slot:[`item.editActions`]="{ }">
      <v-icon
        small class="mr-2"
        tabindex="-1"
      >
        {{icons.mdiPencil}}
      </v-icon>
    </template> -->
  </v-data-table>
</template>

<script>
import {
  mdiPlus,
  mdiDelete,
  mdiPencil,
} from '@mdi/js';
import {
  amountFormat,
  amountToNumber,
} from '../../../util/shared/vue-global';
import ClarionDateControl from '../../common/ClarionDateControl.vue';

const defaultItem = {
  asOfDate: '',
  // description: '',
  // amount: 0.0,
  loc: 0.0,
  pledges: 0.0,
  sweep: 0.0,
  fdic: 0.0,
};

export default {
  name: 'CollateralBankDetails',
  components: {
    ClarionDateControl,
  },
  created() {
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'collateralBankDetails-dialog',
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    // isEditing: false,
    icons: {
      mdiPlus,
      mdiDelete,
      mdiPencil,
    },
    defaultHeaders: [
      { text: 'As Of Date', value: 'asOfDate' },
      // { text: 'Description', value: 'description' },
      // { text: 'Amount', value: 'amount' },
      { text: 'LOC/Collateral', value: 'loc' },
      { text: 'Pledges', value: 'pledges' },
      { text: 'Sweep/ICS', value: 'sweep' },
      { text: 'FDIC', value: 'fdic' },
      { text: 'Delete', value: 'delActions', sortable: false },
      // { text: 'Edit', value: 'editActions', sortable: false },
    ],
  }),
  computed: {
    headers() {
      return this.defaultHeaders;
    },
    editedItem: {
      get() {
        const newVal = JSON.parse(JSON.stringify(this.value));
        const updatedValue = newVal.map(this.loadInitialValues);
        return updatedValue;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    addOne() {
      this.$emit('input', [
        {
          ...defaultItem,
        },
        ...this.editedItem,
      ]);
      // New row goes on top; bring the scroll area back up so it is in view.
      const wrapper = this.$refs.table && this.$refs.table.$el.querySelector('.v-data-table__wrapper');
      if (wrapper) wrapper.scrollTop = 0;
      return true;
    },
    removeOne(item) {
      this.$emit('input', [
        ...this.editedItem.filter((candidate) => item !== candidate),
      ]);
    },
    loadInitialValues(item) {
      return {
        ...item,
        loc: amountFormat(amountToNumber(item.loc)),
        pledges: amountFormat(amountToNumber(item.pledges)),
        sweep: amountFormat(amountToNumber(item.sweep)),
        fdic: amountFormat(amountToNumber(item.fdic)),
      };
    },
    somethingChanged() {
      this.$emit('input', this.editedItem);
    },
    // incomplete functionality
    // editOne(index) {
    //   console.info((index + 1) === (this.editedItem || []).length, '??');
    //   console.info((index), '??');
    //   this.isEditing = !this.isEditing;
    //   // console.info(this.isEditing);
    // },
  },
};
</script>

<style lang="sass">
  .eft-rec-amount input
    text-align: right
</style>

<style scoped src="../../../assets/collateral-compact-table.css"></style>
